import { apiSlice } from "../../api/ApiService";

const patientFhirApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    patientFhirUpdate: builder.mutation({
      query: ({ accessToken, patientFhirId }) => {
        return {
          url: `/api/v1/Patient/fhir-update`,
          method: "PUT",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            patientFhirId: `${patientFhirId}`,
          },
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { usePatientFhirUpdateMutation } = patientFhirApiSlice;
export default patientFhirApiSlice;
